<template>
  <div id="app" class="page-container">
    <md-app style="min-height: 100vh;"  md-waterfall :md-scrollbar=false>
      <md-app-toolbar class="md-primary md-dense">
        <!-- menu //-->
        <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible">
          <md-icon>menu</md-icon>
        </md-button>
        <!-- title //-->
        <span class="md-title" v-if="!status">{{ $t('korak') }} <b>{{ korak }}.</b></span>
        <span class="md-title" v-else>{{ $t('korak_0_naslov') }}</span>
        <!-- jezik //-->
        <md-menu md-size="auto" md-align-trigger md-close-on-click md-direction="bottom-start" style="margin-left: auto;">
          <md-button md-menu-trigger>
            <md-icon>language</md-icon>
            <span> {{ $t('jezik') }} </span>
          </md-button>
          <md-menu-content>
            <md-menu-item>
              <md-radio v-model="$i18n.locale" value="bs" v-on:change="jezik('bs')">Bosanski</md-radio>
            </md-menu-item>
            <md-menu-item>
              <md-radio v-model="$i18n.locale" value="en" v-on:change="jezik('en')">English</md-radio>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </md-app-toolbar>
      <md-app-drawer id="drawer" :md-active.sync="menuVisible" md-fixed md-persistent="mini">
        <md-toolbar class="md-transparent" md-elevation="0">
          <span>{{ $t('navigacija_naslov') }}</span>
          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>keyboard_arrow_left</md-icon>
            </md-button>
          </div>
        </md-toolbar>
        <md-list>
          <md-list-item>
            <md-icon v-bind:class="[{ 'md-primary': (korak >= 1 && !status ) }]">contacts</md-icon>
            <div class="md-list-item-text">
              <span>{{ $t('korak_1_naslov') }}</span>
              <p>{{ $t('korak_1_podnaslov') }}</p>
            </div>
          </md-list-item>

          <md-list-item>
            <md-icon v-bind:class="[{ 'md-primary': (korak >= 2) }]">ballot</md-icon>
            <div class="md-list-item-text">
              <span>{{ $t('korak_2_naslov') }}</span>
              <p>{{ $t('korak_2_podnaslov') }}</p>
            </div>
          </md-list-item>

          <md-list-item>
            <md-icon v-bind:class="[{ 'md-primary': (korak >= 3) }]">insert_chart_outlined</md-icon>
            <div class="md-list-item-text">
              <span>{{ $t('korak_3_naslov') }}</span>
              <p>{{ $t('korak_3_podnaslov') }}</p>
            </div>
          </md-list-item>

          <md-list-item>
            <md-icon v-bind:class="[{ 'md-primary': (korak >= 4) }]">done_all</md-icon>
            <div class="md-list-item-text">
              <span>{{ $t('korak_4_naslov') }}</span>
              <p>{{ $t('korak_4_podnaslov') }}</p>
            </div>
          </md-list-item>
        </md-list>

        <md-speed-dial md-direction="top" style="align-self: center;">
          <md-speed-dial-target class="md-primary md-dense md-raised">
            <md-icon class="md-morph-initial">favorite</md-icon>
            <md-icon class="md-morph-final">fingerprint</md-icon>
          </md-speed-dial-target>

          <md-speed-dial-content>
            <md-button class="md-icon-button" href="https://radionica.digital" target="_blank">
              <md-icon class="md-size-x3">local_post_office</md-icon>
            </md-button>
            <md-button class="md-icon-button" href="http://www.facebook.com/share.php?u=https://koraci.radionica.digital" target="_blank">
              <md-icon>share</md-icon>
            </md-button>
            <md-button class="md-icon-button" href="https://github.com/smajlagic" target="_blank">
              <md-icon>code</md-icon>
            </md-button>
          </md-speed-dial-content>
        </md-speed-dial>

      </md-app-drawer>
      
      <md-app-content>
        <md-progress-bar class="md-accent" md-mode="determinate" :md-value="(korak*25)" v-show="!status"></md-progress-bar>
        <form novalidate>
          
          <transition name="slide-fade">
            <div v-if="korak === 1">
              <Korak_1 />
            </div>
          </transition>
          
          <transition name="slide-fade">
            <div v-if="korak === 2">
              <Korak_2 />
            </div>
          </transition>
          
          <transition name="slide-fade">
            <div v-if="korak === 3">
              <Korak_3 />
            </div>
          </transition>
          
          <transition name="slide-fade">
            <div v-if="korak === 4">
              <Korak_4 />
            </div>
          </transition>

        </form>
        
      </md-app-content>
    </md-app>

    <md-snackbar class="md-layout" :md-duration=0 md-position="center" :md-active=upozorenje v-show="!status">
      <span class="md-layout-item md-size-80">{{ $t('upozorenje') }}</span>
      <md-button class="md-layout-item md-accent md-size-20" @click="sakrijUpozorenje">{{ $t('u_redu') }}</md-button>
    </md-snackbar>
  </div>
</template>

<script>
const Korak_1 = () => import( /* webpackChunkName: "korak-1" */ './components/korak-1.vue' );
const Korak_2 = () => import( /* webpackChunkName: "korak-2" */ './components/korak-2.vue' );
const Korak_3 = () => import( /* webpackChunkName: "korak-3" */ './components/korak-3.vue' );
const Korak_4 = () => import( /* webpackChunkName: "korak-4" */ './components/korak-4.vue' );

export default {
  name: 'app',
  data: () => ({
    menuVisible: false,
    langs: ['en', 'bs']
  }),
  components: {
    Korak_1,
    Korak_2,
    Korak_3,
    Korak_4
  },
  methods: {
    toggleMenu () {
      this.menuVisible = !this.menuVisible
    },
    sakrijUpozorenje () {
      this.$store.commit('upozorenje', this.upozorenje)
    },
    jezik (izabrano) {
      this.$store.commit('jezik', izabrano)
    },
    detektujScroll (event) {
      let drawer = document.getElementById("drawer")
      if(window.scrollY < 48) {
        drawer.classList.add('ima-scroll'); 
        let position = (48 - window.scrollY);
        drawer.style.transform = "translate3d(0, "+position+"px, 0)";
      } else {
        drawer.classList.remove('ima-scroll'); 
        drawer.style.transform = "translate3d(0, 0px, 0)";
      }
    }
  },
  computed: {
    korak () {
      return this.$store.state.korak
    },
    upozorenje () {
      return this.$store.state.upozorenje
    },
    status () {
      return this.$store.state.zavrseno
    }
  },
  created () {
    window.addEventListener('scroll', this.detektujScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.detektujScroll);
  }
}
</script>